import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { Star, Loader2 } from 'lucide-react';
import { DealMiniTable } from '../components/DealMiniTable';

export default function FavoritesPage() {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.getFavoriteDeals();
      setDeals(res.data || []);
    } catch { toast.error('Failed to load favorites'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const removeFavorite = async (id) => {
    try {
      await api.toggleFavorite(id);
      setDeals(prev => prev.filter(d => d.id !== id));
      toast.success('Removed from favorites');
    } catch { toast.error('Failed to remove favorite'); }
  };

  return (
    <div className="space-y-6 animate-fade-in-up" data-testid="favorites-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl text-foreground tracking-tight flex items-center gap-2.5">
          <Star className="w-6 h-6 text-amber-400" fill="currentColor" /> My Favorites
        </h1>
        <p className="text-muted-foreground text-xs sm:text-sm mt-1">Deals you starred — shared visibility across the team</p>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-20"><Loader2 className="w-6 h-6 text-blue-500 animate-spin" /></div>
      ) : deals.length === 0 ? (
        <div className="text-center py-24 border border-border rounded-sm bg-card" data-testid="favorites-empty">
          <Star className="w-10 h-10 text-muted-foreground/40 mx-auto mb-4" strokeWidth={1.5} />
          <p className="text-foreground text-sm font-medium mb-1">No favorites yet</p>
          <p className="text-muted-foreground/60 text-xs">Click the star icon on any deal to add it to your favorites.</p>
        </div>
      ) : (
        <DealMiniTable deals={deals} type="favorite" onRemove={removeFavorite} />
      )}
    </div>
  );
}
